<app-page-header title="Promotion Status" description="Maintain the list of statuses a promotion can be in."></app-page-header>
<div class="grid">
<dx-data-grid #promotionStatusGrid
  [dataSource]="dataSource"
  [remoteOperations]="true"
  [allowColumnReordering]="false"
  [rowAlternationEnabled]="true"
  [height]="'100%'"
>
<dxo-editing
    mode="batch"
    [allowAdding]="true"
    [allowUpdating]="true"
    [allowDeleting]="true"
  >
  </dxo-editing>
  <dxo-scrolling mode="virtual"></dxo-scrolling>
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxi-column dataField="status" dataType="integer" caption="Status">
    <dxi-validation-rule type="required" message="Status is required"></dxi-validation-rule>
    <dxi-validation-rule type="numeric" message="Status must be a valid integer"></dxi-validation-rule>
    <dxi-validation-rule type="range" [min]="0" message="Status must be a positive integer"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="name" dataType="string" caption="Name">
    <dxi-validation-rule type="required" message="Name is required"></dxi-validation-rule>
    <dxi-validation-rule type="stringLength" [max]="40" message="Name cannot exceed 40 characters"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="type" caption="Type">
    <dxo-lookup
      [dataSource]="promotionStatusTypes"
      valueExpr="type"
      displayExpr="name"
    ></dxo-lookup>
  </dxi-column>
</dx-data-grid>
</div>